import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import '../assets/styles/SecNavbar.css';
import '../assets/styles/Global.css'

/* Secondary Navbar component that is used in the AboutUs, MyAccount and OurLeaders pages.
Take the clicked page as an argument and return the secondary navbar with the links */


const SecNavbar = ({}) => {
  let pageList = [];
  let page = window.location.pathname.split('/')[1];

  switch (page){
    case 'myaccount' :
      pageList = [
        {name: 'Sign in', link: '/myaccount/signin'},
        {name: 'Register', link: '/myaccount/register'}
      ];
      break;
    case 'aboutus' :
      pageList = [
        {name: 'Services', link: '/aboutus/services'},
        {name: 'Practices', link: '/aboutus/practices'},
        {name: 'Clients', link: '/aboutus/clients'},
        {name: 'Exec Partners', link: '/aboutus/execpartners'},
        {name: 'Consultants', link: '/aboutus/consultants'},
        {name: 'IQosystem', link: '/aboutus/iqosystem'},
        {name: 'IQS Tokens', link: '/aboutus/iqstokens'}
      ];
      break;
    case 'ourleaders' :
      pageList = [
        {name: 'Sector', link: '/ourleaders/sector'},
        //{name: 'Function', link: '/ourleaders/function'},
        {name: 'Practice', link: '/ourleaders/practice'}
      ];
      break;
      default:
      pageList = [];
      break;
  }

  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/') ;
  };
  
  return (
    <>
      {pageList.length > 0 && (
        <Navbar expand="sm" className="secondary-navbar w-100 p-0">
          <Nav className="ml-auto">
            {pageList.map((page, index) => ( 
                <Nav.Link 
                  key={index}
                  as={NavLink}
                  to={page.link}
                  className={isActive(page.link) ? 'active-sec-link' : 'unactive-sec-link'}
                >
                  {page.name}
                </Nav.Link>
            ))}
          </Nav>
        </Navbar>)}
      <hr className="my-custom-hr"/>
    </>
  );
}

export default SecNavbar;